import { render, staticRenderFns } from "./PartnerInfoSection.vue?vue&type=template&id=c227f830"
import script from "./PartnerInfoSection.vue?vue&type=script&lang=js"
export * from "./PartnerInfoSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports